import { Vector2 } from "api/types/sketch";
import { OrderCutBump } from "api/types/order/order";
import { SelfOrderCutBump } from "api/types/order/self_order";
import { drawPrintCutFullWidth } from "../full_arc/print_cut_full_arc";
import { drawPrintCutBumpIn } from "../bump_in/print_cut_bump_in";
import { drawPrintCutBumpInArc } from "../bump_in_arc/print_cut_bump_in_arc";
import { drawPrintCutBumpOut } from "../bump_out/print_cut_bump_out";
import { drawPrintCutBumpOutArc } from "../bump_out_arc/print_cut_bump_out_arc";
import { FULL_ARC } from "values/values";
import { NO_BUMP } from "values/values";
import { BUMP_IN } from "values/values";
import { BUMP_IN_ARC } from "values/values";
import { BUMP_OUT } from "values/values";
import { BUMP_OUT_ARC } from "values/values";

export function drawPrintCutBumps(
  painter: any,
  unsorted_bumps: OrderCutBump[] | SelfOrderCutBump[],
  current_location: Vector2,
  next_location: Vector2,
  angle: number,
  zoom: number
) {
  let is_full_arc: boolean = false;
  const bumps: OrderCutBump[] | SelfOrderCutBump[] = [...unsorted_bumps];
  bumps.sort(function (a, b) {
    if (a.distance < b.distance) {
      return -1;
    }
    else if (a.distance > b.distance) {
      return 1;
    }
    else {
      return 0;
    }
  });

  for (let j = 0; j < bumps.length; j++) {
    if (bumps[j].bump_type === FULL_ARC) {
      is_full_arc = true;
      drawPrintCutFullWidth(
        painter,
        current_location,
        next_location,
        bumps[j].depth,
        angle,
        zoom
      );
    }
  }

  if (!is_full_arc) {
    for (let j = 0; j < bumps.length; j++) {
      if (bumps[j].bump_type === NO_BUMP) {
        continue;
      }
      else if (bumps[j].bump_type === BUMP_IN) {
        drawPrintCutBumpIn(
          painter,
          current_location,
          next_location,
          bumps[j].distance,
          bumps[j].width,
          bumps[j].depth,
          angle,
          bumps[j].left_side_angle,
          bumps[j].right_side_angle,
          zoom
        );
      }
      else if (bumps[j].bump_type === BUMP_OUT) {
        drawPrintCutBumpOut(
          painter,
          current_location,
          next_location,
          bumps[j].distance,
          bumps[j].width,
          bumps[j].depth,
          angle,
          bumps[j].left_side_angle,
          bumps[j].right_side_angle,
          zoom
        );
      }
      else if (bumps[j].bump_type === BUMP_IN_ARC) {
        drawPrintCutBumpInArc(
          painter,
          current_location,
          next_location,
          bumps[j].distance,
          bumps[j].width,
          bumps[j].depth,
          angle,
          zoom
        );
      }
      else if (bumps[j].bump_type === BUMP_OUT_ARC) {
        drawPrintCutBumpOutArc(
          painter,
          current_location,
          next_location,
          bumps[j].distance,
          bumps[j].width,
          bumps[j].depth,
          angle,
          zoom
        );
      }
    }
  }
}
